import {NumberUtil} from "base/format/utilities";
import {TextLink} from "base/navigation/components";

export function useFellingTreesTable() {
    const tableColumns = [
        {
            id: "code",
            label: "Código",
            width: 15,
            formatFunction: item => (
                <TextLink
                    text={item?.code}
                    to={`#${item.code}`}
                    textStyle={{fontSize: "inherit"}}
                    isHashLink
                />
            ),
        },
        {
            id: "species",
            label: "Espécie",
            width: 15,
        },
        {
            id: "quality",
            label: "Qualidade",
            width: 15,
        },
        {
            id: "volume",
            label: "Volume",
            width: 15,
            textAlign: "right",
            formatFunction: item =>
                item.volume ? `${NumberUtil.formatDecimal(item.volume)} m³` : null,
        },
        {
            id: "felling_fee",
            label: "Taxa abate",
            width: 15,
            textAlign: "right",
            formatFunction: item =>
                item.felling_fee
                    ? `${NumberUtil.formatCurrency(item.felling_fee)}/m³`
                    : null,
        },
        {
            id: "felling_price",
            label: "Valor pago",
            width: 15,
            textAlign: "right",
            formatFunction: item => NumberUtil.formatCurrency(item.felling_price),
        },
    ];

    return {tableColumns};
}
